import { FakeLoginView } from './fake-login'

export const AuthDevPage: React.FC = () => {
    return (
        <div>
            <FakeLoginView />
        </div>
    )
}
